import cn from 'classnames';
import Image from 'next/future/image';
import { FCP } from 'types';

import { importStatic } from 'utils';

import classes from './coverImage.module.css';

export interface CoverImageProps extends FCP {
  url: string;
}

export const CoverImage = ({ url = '' }: CoverImageProps) => {
  const defaultImage = importStatic('/ui-router/images/cpp-cover.webp');
  return (
    <div
      className={cn(
        'position-relative overflow-hidden container-fluid d-flex align-items-center justify-content-center',
        classes.container
      )}
    >
      <div
        className={cn('position-absolute', classes.cover, {
          [classes.limited]: url,
        })}
      >
        <Image
          src={url || defaultImage}
          sizes="100vw"
          quality={100}
          fill
          alt="Company cover image"
          priority
        />
      </div>
    </div>
  );
};
